import { useSurveyArchive } from "@/queries/surveys/use-surveys.query.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { ApiSurveyStatus, SurveyStatusItems } from "@/types/survey.types.ts";
import { ConfirmationModal, Tag, TagVariants, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface SurveyDeleteActionParams {
  id: number;
}

export const useSurveysHook = () => {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const surveyArchive = useSurveyArchive();

  const getSurveyStatusTag = (entity: ApiSurveyStatus) => {
    let tagVariant: TagVariants = "positive";
    switch (entity) {
      case ApiSurveyStatus.draft:
        tagVariant = "warning";
        break;
      case ApiSurveyStatus.running:
        tagVariant = "positive";
        break;
      case ApiSurveyStatus.paused:
        tagVariant = "secondary";
        break;
      case ApiSurveyStatus.completed:
        tagVariant = "secondary";
        break;
      case ApiSurveyStatus.pending_launch:
        tagVariant = "positive";
        break;
    }

    return <Tag variant={tagVariant}>{SurveyStatusItems().find((x) => x.id == entity)?.title}</Tag>;
  };

  const handleDeleteSurvey = (survey: SurveyDeleteActionParams, onSuccess?: () => void) => {
    openModal(ConfirmationModal, {
      question: t("common:delete"),
      text: t("common:delete_confirm"),
      acceptTitle: t("common:delete"),
      onAccept: async function () {
        try {
          await surveyArchive.mutateAsync({ id: survey.id });
          analyticsService.trackEvent(analyticEvents.surveys.deleted, {
            [analyticProperties.id]: survey.id,
          });
          onSuccess?.();
        } catch {
          return;
        }
      },
    });
  };

  return {
    getSurveyStatusTag,
    handleDeleteSurvey,
    isDeletePending: surveyArchive.isPending,
  };
};
